import { ReactNode, Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";

export type SuspenseQueryWrapperProps = {
  condition?: boolean;
  children: () => ReactNode;
  loadingFallback?: ReactNode;
  errorFallback?: ReactNode;
  emptyState?: ReactNode;
};

export function SuspenseQueryWrapper({
  condition = true,
  children,
  loadingFallback = <div>Loading...</div>,
  errorFallback = <div className="text-red-500">Error loading content</div>,
  emptyState = <div>No content available</div>,
}: SuspenseQueryWrapperProps) {
  if (!condition) {
    return <>{emptyState}</>;
  }

  return (
    <ErrorBoundary FallbackComponent={() => <>{errorFallback}</>}>
      <Suspense fallback={loadingFallback}>{children()}</Suspense>
    </ErrorBoundary>
  );
}
